import React from 'react';

const ShopCheck = () => {
    // useEffect(() => {
    //     //Single Product Price Calculate
    //     function CalcPrice(qty) {
    //         var price = $(".product_per_price").attr("data-content");
    //         var total = parseFloat((price * qty)).toFixed(2);
    //         $(".product_total_price").text(total);
    //     }
    //     $(document).on("click", ".product_quantity_subtract", function (e) {
    //         var value = $("#product_quantity_input").val();
    //         var newValue = parseInt(value) - 1;
    //         if (newValue < 0) newValue = 0;
    //         $("#product_quantity_input").val(newValue);
    //         CalcPrice(newValue);
    //     });
    //     $(document).on("click", ".product_quantity_add", function (e) {
    //         var value = $("#product_quantity_input").val();
    //         var newValue = parseInt(value) + 1;
    //         $("#product_quantity_input").val(newValue);
    //         CalcPrice(newValue);
    //     });
    //     $(document).on("blur", "#product_quantity_input", function (e) {
    //         var value = $("#product_quantity_input").val();
    //         CalcPrice(value);
    //     });

    //     // Cart open
    //     $('a.cart_icon').on('click', function (e) {
    //         e.preventDefault();
    //         $('.cart_box').toggleClass('active');
    //     });

    //     // Select2 JS
    //     $(".select_dropdown_value").select2();

    //     // Coupon open
    //     $('.opencoupon a.button').on('click', function (e) {
    //         e.preventDefault();
    //         $('.couponform').toggleClass('active');
    //     });

    //     // Totop Button
    //     $('.totop a').on('click', function (e) {
    //         e.preventDefault();
    //         $('html, body').animate({ scrollTop: 0 }, '500');
    //     });


    // }, []);
    return (
        <div className="main-wrapper">
            <div className="shopping_cart">
                <div className="container">
                    <div className="shipping_form">
                        <div className="shipping_couponcart">
                            <div className="opencoupon">
                                <div className="text">Coupon Code</div>
                                <div className="button_group">
                                    <a className="button" href="#">Click Here to Apply Coupon</a>
                                </div>
                            </div>
                            <form className="couponform" action="coupon.php" method="POST">
                                <div className="form-group">
                                    <label for="coupon">It you have a coupon code, please apply it below</label>
                                    <input type="text" className="form-control" id="coupon" name="coupon" placeholder="Coupon Code" />
                                </div>
                                <div className="button_group">
                                    <input className="button" type="submit" value="Apply Coupon" name="submit" />
                                </div>
                            </form>
                        </div>
                        <form action="shipping.php" method="POST">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="label_shipping">
                                        <h3>Billing Details</h3>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                <label for="fname">First Name*</label>
                                                <input type="text" className="form-control" id="fname" name="fname" placeholder="" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                <label for="lname">Last Name*</label>
                                                <input type="text" className="form-control" id="lname" name="lname" placeholder="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label for="company">Company Name</label>
                                        <input type="text" className="form-control" id="company" name="company" placeholder="" />
                                    </div>
                                    <div className="form-group">
                                        <label for="country">Country*</label>
                                        <select className="select_dropdown_value" id="country">
                                            <option value="1">United States of America</option>
                                            <option value="2">Country 2</option>
                                            <option value="3">Country 3</option>
                                            <option value="4">Country 4</option>
                                            <option value="5">Country 5</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label for="street">Street Address*</label>
                                        <input type="text" className="form-control" id="street" name="street" placeholder="House No & Street Name" />
                                    </div>
                                    <div className="form-group">
                                        <label for="city">Town / City*</label>
                                        <select className="select_dropdown_value" id="city">
                                            <option value="1">New York</option>
                                            <option value="2">Washington DC</option>
                                            <option value="3">New Jersey</option>
                                            <option value="4">Alska</option>
                                            <option value="5">Arizona</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label for="district">District</label>
                                        <input type="text" className="form-control" id="district" name="district" placeholder="House No & Street Name" />
                                    </div>
                                    <div className="form-group">
                                        <label for="zip">Postcode / Zip</label>
                                        <input type="text" className="form-control" id="zip" name="zip" placeholder="House No & Street Name" />
                                    </div>
                                    <div className="form-group">
                                        <label for="phone">Phone*</label>
                                        <input type="text" className="form-control" id="phone" name="phone" placeholder="012345" />
                                    </div>
                                    <div className="form-group">
                                        <label for="email">Email Address*</label>
                                        <input type="email" className="form-control" id="email" name="email" placeholder="mail@domain.com" />
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    <div className="additional_info">
                                        <div className="label_shipping">
                                            <h3>Additional Information</h3>
                                        </div>
                                        <div className="form-group">
                                            <label for="info">Order Notes (Optional)</label>
                                            <textarea id="info" name="info" className="form-control" placeholder="Notes about your order, e.g. Special Notes for Delivery*" required=""></textarea>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-7">
                                    <div className="checkout_cart_total">
                                        <h3 className="grand_title">Cart Total</h3>
                                        <ul>
                                            <li><span className="cost_per">Subtotal</span> <span className="value">$1500</span></li>
                                            <li><span className="cost_per">Tax (10%)</span> <span className="value">$150</span></li>
                                            <li><span className="cost_per">Shipping</span> <span className="value">$50</span></li>
                                            <li className="totalvalue"><span className="cost_per">Total</span> <span className="value">$1700</span></li>
                                        </ul>
                                    </div>

                                    <div className="check_payment_group">
                                        <div className="check_payment">
                                            <label className="radio_circle">Check Payments
                                                <input type="radio" checked="checked" name="paymethod" value="cash" />
                                                <span className="checkmark"></span>
                                            </label>
                                            <p className="payment_message">Please send a check to Store Name, Store Street, Store Town, Store State/ Country, Store Postcode.</p>
                                        </div>
                                        <div className="check_payment paytype">
                                            <label className="radio_circle">PayPal
                                                <input type="radio" name="paymethod" value="card" />
                                                <span className="checkmark"></span>
                                            </label>
                                            <input type="text" className="form-control" id="paypal" name="paypal" placeholder="" />
                                        </div>
                                        <div className="check_payment">
                                            <p>Your personal data will be used to process your order, support your experience throughout this website and for other
                                                porposes described in our privacy policy.</p>
                                        </div>
                                    </div>
                                    <div className="button_group">
                                        <input className="button" type="submit" value="Place Order" name="submit" />
                                    </div>
                                </div>


                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShopCheck;